import CustomComponentSlot from '../../custom-component-slot/CustomComponentSlot'
import { useAccountPageUIContext } from '../AccountPageProvider'
import { AccountCustomPage } from '../types'

// A page whose whole UI is merchant HTML. Mounted only while its tab is active,
// so scripts run on open and re-run when the user's details change.
const CustomPageUI = ({ page }: { page: AccountCustomPage }) => {
  const { data } = useAccountPageUIContext()
  const user = data?.profilePage?.user
  // The user object is rebuilt on unrelated data changes, so compare by value.
  const userKey = [user?.name, user?.phone, user?.primaryEmail].join('|')

  return (
    <div className='ui-w-full'>
      <CustomComponentSlot html={page.html} rerunDeps={[userKey]} />
    </div>
  )
}

export default CustomPageUI
